import React, {useEffect, useState} from 'react';
import {
  Button,
  Drawer,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  TextareaAutosize,
  // IconButton,
  Theme,
  Tooltip,
  // Tooltip,
  createStyles,
  makeStyles
} from '@material-ui/core';
import {
  APP,
  APP_PRIMARY_COLOR,
  BORDER_COLOR,
  DEFAULT_BLACK_COLOR,
  DEFAULT_WHITE_COLOR,
  FONT_PRIMARY_COLOR
} from 'src/style/variable';
import {Trans, useTranslation} from 'react-i18next';
import {useSnackbar} from 'notistack';
import {useSelector} from 'react-redux';
// import {deleteVisitTypeConfiguration} from '@shared/services/WorkflowServices';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import {Column} from 'material-table';
import {/* startOfMonth, */ format} from 'date-fns';
import GridTable, {
  DEFAULT_GRID_TABLE__OPTIONS
} from '@components/system/GridTable/GridTable';
import {
  PAGINATION_SIZE,
  PAGINATION_SIZE_OPTIONS
} from 'src/constants/SystemConstants';
import '../../../../../modules/Invoices/Drawer/DrawerComponentStyles.scss';
// import Delete from '@components/system/MyIcons/Delete';
import {Permission} from '@shared/services/PermissionService';
import {State} from '@shared/store/reducers/Index';
import {AppPermissions} from '@shared/constants/Mapping';
// import DeleteAlert from 'src/modules/admin/modules/Patients/DeleteAlert/DeleteAlert';
import AddPatientProblem from '../../AddPatientProblemsDetails/AddPatientProblem';
import {FormField} from '@components/system/FormField/FormField';
import {Controller, useForm} from 'react-hook-form';
import {
  enrollForCCM,
  fetchPatientProblems,
  getAllPatientProblems,
  updateCCMPatientDetails
} from '@shared/services/CCMServices';
import Loader from '@components/framework/loader/Loader';
import Delete from '@components/system/MyIcons/Delete';
import DeleteAlert from 'src/modules/admin/modules/Patients/DeleteAlert/DeleteAlert';
import {
  billingMonthTextColor,
  spaceBottomStyle
} from '../../EnrollCCMDialog/CCMDialog/CCMEnrollmentDialogStyle';
import DateTimePickerWrapper from '@components/system/CustomDateTimePicker/DateTimePickerWrapper';
import moment from 'moment';
import DragAndDrop from '@components/system/DragAndDrop/DragAndDrop';
import CCMEnrollementDialogUtils from '../../EnrollCCMDialog/CCMDialog/CCMEnrollementDialogUtils';
import WithPermission from '@components/system/WithPermission/WithPermission';

interface ViewPatientProblemsDrawerComponentProps {
  open: boolean;
  closeDrawer(): void;
  patientProblemsData?: any;
  clinicId?: number;
  refreshMainGrid?: any;
  ccmEnrolleData?: any;
  patientName?: any;
  accountNumber?: any;
  patientId?: any;
  isChronic?: any;
}
export interface IPatientProblem {
  problem: string;
  icd10_code: string;
  is_chronic: string;
  id: number;
}
type StateProps = {
  consentType: string;
  consentFile: File | null | any;
  verbalNotes: string;
  BillingMonth: string;
  buttonLoader: boolean;
};

const styles = makeStyles((theme: Theme) =>
  createStyles({
    ConsentRadioStyle: {
      '& .MuiRadio-root': {
        padding: '9px 2px 9px 9px'
      }
    },
    optionalFieldsWrapper: {
      display: 'flex',
      gap: '1rem',
      flexDirection: 'column',
      marginBottom: '1rem'
    },
    ccmStartDateFeild: {
      '& .MuiFormControl-root': {
        marginBottom: '0rem',
        paddingBottom: '0rem'
      }
    },
    drawer: {
      '& .MuiBackdrop-root': {
        backgroundColor: 'transparent'
      },
      '& .MuiDrawer-paperAnchorRight': {
        width: '70%',
        height: `calc(100vh - 40px)`,
        backgroundColor: DEFAULT_WHITE_COLOR,
        marginTop: theme.mixins.toolbar.minHeight,
        zIndex: 1300,
        borderLeft: `1px solid ${BORDER_COLOR}`
      }
    },
    loaderStyle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    moreFilters: {
      height: '2.3rem',
      width: '5rem',
      lineHeight: '1rem',
      borderColor: APP_PRIMARY_COLOR,
      color: DEFAULT_WHITE_COLOR,
      fontSize: '1rem',
      backgroundColor: APP_PRIMARY_COLOR,
      '&:hover': {
        backgroundColor: APP_PRIMARY_COLOR
      }
    },
    drawerWrapper: {
      overflow: 'auto',
      paddingInline: 0,
      // height: 'inherit',
      '& .content-view .header-and-close-section': {
        paddingInline: '1rem'
      }
    },
    drawerTitleAndBody: {
      height: '100%'
    },
    titleSection: {
      flex: '0 !important'
    },
    patientProblemsGridWrapper: {
      padding: '1rem',
      flex: 1,
      display: 'grid',
      overflow: 'hidden',
      '& > div > div > div > div': {
        overflow: 'visible !important'
        // width: '30rem'
      },
      '& .MuiTablePagination-actions': {
        display: 'hidden !important' // Hides pagination arrows
      },
      '& span[title="First Page"], & span[title="Previous Page"], & span[title="Next Page"], & span[title="Last Page"]': {
        visibility: 'hidden !important' // Hides only the pagination buttons
      },
      /*  Targets the first child (div) inside patientProblemsGridWrapper */
      '& > div:first-child': {
        /*  Targets the first child inside that div */
        '& > div:first-child': {
          margin: '0 auto 0 -40px',
          padding: 0,
          position: 'relative',
          top: '10px'
        },
        '& > div:first-child > div:nth-child(2)': {
          width: '400px !important'
        }
      }
    },
    customIconButton: {
      padding: '4px',
      '& svg': {
        width: '24px',
        height: '24px'
      }
    },
    actionsColumnWrapper: {
      display: 'flex',
      gap: '0.5rem'
    },
    actionIconButtonWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  })
);

const CCMPatientProblemsDrawer = (
  props: ViewPatientProblemsDrawerComponentProps
): JSX.Element => {
  const {
    open,
    closeDrawer,
    patientProblemsData,
    clinicId,
    refreshMainGrid,
    ccmEnrolleData,
    patientName,
    accountNumber,
    patientId,
    isChronic
  } = props;
  const classes = styles();
  const {t} = useTranslation();
  const tableRef: any = React.useRef();
  const {enqueueSnackbar} = useSnackbar();
  const {groupId} = useSelector((state: any) => state.auth);

  // const [dropdownOptions, setDropdownOptions] = useState<IPatientProblem[]>([]);

  const closePopUp = (): void => {
    if (typeof closeDrawer === 'function') {
      closeDrawer();
    }
  };
  const {patientDetails} = useSelector(
    (state: any) => state.patientDetailsDrawer
  );

  const [state, setState] = useState<StateProps>({
    consentType: '',
    consentFile: null,
    verbalNotes: '',
    BillingMonth: CCMEnrollementDialogUtils.CurrentMonthAndYear(),
    buttonLoader: false
  });
  const {
    consentType,
    consentFile,
    verbalNotes,
    BillingMonth,
    buttonLoader
  } = state;
  const handleConsentTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setState(prevState => ({
      ...prevState,
      consentType: event?.target?.value
    }));
  };
  const handleConsentFileChange = (files: any): void => {
    const data = new FormData();
    const file = files[0];
    if (!file) {
      return setState(prevState => ({
        ...prevState,
        consentFile: null
      }));
    }
    data.append('inputname', file);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      if (file.size === 0) {
        enqueueSnackbar(t('ADD_CLINIC.EMPTY_FILE'), SnackBarConfig('w'));
      } else {
        setState(prevState => ({
          ...prevState,
          consentFile: files[0]
        }));
      }
    };
  };
  const disableEnrollButton = () => {
    if (consentType === t('CCM.WRITTEN')) {
      return consentFile === null;
    } else if (consentType === t('CCM.VERBAL')) {
      return !verbalNotes;
    }
    return true;
  };
  const enrollPatientForCCM = async (
    file: any,
    clinicalGroupId: number,
    enrollmentDate: Date,
    data: any
  ): Promise<void> => {
    try {
      const activeProblemIds = activeValues.map(
        (row: IPatientProblem) => row.id
      );
      const combinedActiveProblems = [...activeProblemIds];

      setState(prevState => ({
        ...prevState,
        buttonLoader: true
      }));
      const payload: any = {
        patient_id: patientId,
        consent_type: consentType,
        notes: verbalNotes,
        file: file,
        enrollment_date: enrollmentDate,
        billing_provider: data?.billing_provider,
        active_problems: combinedActiveProblems
      };

      const options: Record<string, any> = {};
      if (clinicId ?? acOfClinics?.[0]) {
        options.clinic_id = clinicId ?? acOfClinics?.[0];
      }

      const res = await enrollForCCM(clinicalGroupId, payload, options);
      if (res) {
        setState(prevState => ({
          ...prevState,
          buttonLoader: false
        }));

        enqueueSnackbar(t('CCM.USER_ENROLLED'), SnackBarConfig('s'));
        if (typeof refreshMainGrid === 'function') {
          refreshMainGrid();
        }
        closePopUp();
      }
    } catch (error: any) {
      setState(prevState => ({
        ...prevState,
        buttonLoader: false
      }));
      enqueueSnackbar(error && error?.message, SnackBarConfig('e'));
    }
  };
  // Date selection for enrolling into CCM in the current month function start //
  const handleOnChange = (event: any, country: any | null, key: any): any => {
    // event.persist();
    // event.target.setAttribute('autocomplete', 'off');
  };

  const handleEnrollClick = (data: any) => {
    const selectedEnrollmentDate: any = format(
      data?.enrollment_start_date?.toDate(),
      'yyyy-MM-dd'
    );
    // call the function to enroll into the CCM
    enrollPatientForCCM(consentFile, groupId, selectedEnrollmentDate, data);
  };
  const handleVerbalNotesChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    event.persist();
    setState(prevState => ({
      ...prevState,
      verbalNotes: event.target.value
    }));
  };
  const [gridRowsData, setGridRowsData] = useState([]);
  const [loader, setLoader] = useState(true);
  // const [checkedData, setCheckedData] = useState([]);

  const fetchPatientProblemList = async (ccmPatientId: number) => {
    try {
      const params: {clinic_id?: any; is_chronic?: any} = {};
      if (clinicId) {
        params.clinic_id = clinicId;
      }
      if (isChronic) {
        params.is_chronic = isChronic;
      }
      const res = await fetchPatientProblems({
        ccm_patient_id: ccmPatientId,
        clinic_group_id: groupId,
        params
      });
      if (res?.data?.billing_provider) {
        setValue('billing_provider', res?.data?.billing_provider);
      }
      if (res?.data?.patient_problems) {
        const transformedData = res.data.patient_problems.map(
          (problem: any) => ({
            problem: problem?.patient_problem?.patient_problem,
            icd10_code: problem?.patient_problem?.icd10_code,
            is_chronic: problem?.patient_problem?.is_chronic,
            id: problem?.patient_problem?.id,
            actions: null
          })
        );
        setLoader(false);
        setGridRowsData(transformedData);
        return transformedData;
      } else {
        setLoader(false);
        setGridRowsData([]);
      }
    } catch (e) {
      setLoader(false);
      setGridRowsData([]);
      if (e?.message) {
        enqueueSnackbar(e.message, SnackBarConfig('error'));
      }
    }
  };

  useEffect(() => {
    if (gridRowsData?.length > 0) {
      setValue(
        'active_problems',
        gridRowsData.map(data => ({...data}))
      );
    } else {
      setValue('active_problems', []);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gridRowsData]);

  const fetchAllPatientProblemsWithMatchingText = async (
    searchText: string
  ) => {
    try {
      const params: Parameters<
        typeof getAllPatientProblems
      >['0']['params'] = {};
      params.search_text = searchText;

      if (clinicId) {
        params.clinic_id = clinicId;
      }
      const response = await getAllPatientProblems({
        clinic_group_id: groupId,
        params
      });

      if (response.data.rows) {
        const fetchedOptions = response.data.rows.map((item: any) => ({
          id: item.id,
          icd10_code: item.icd10_code,
          problem: item.patient_problem,
          label: `${item.icd10_code}-${item.patient_problem}`,
          is_chronic: item.is_chronic ?? false
          // disabled: gridRowsData.some(row => row.id === item.id)
          // checked: checkedData.some((checked) => checked.id === item.id), // Ensure checked items stay checked
        }));

        return fetchedOptions;
        // setDropdownOptions(fetchedOptions); // Store data locally
      }
    } catch (err: any) {
      enqueueSnackbar(err?.message, SnackBarConfig('e'));
    }
  };

  useEffect(
    () => {
      if (patientProblemsData?.ccmPatientId) {
        fetchPatientProblemList(patientProblemsData?.ccmPatientId);
      } else {
        setLoader(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [patientProblemsData?.ccmPatientId]
  );

  const handleCCMPatientDetails = async (data: any) => {
    try {
      if (
        (!patientProblemsData.ccmPatientId &&
          !patientDetails?.ccm_patient_id) ||
        !groupId
      ) {
        return;
      }
      const params: {clinic_id?: number} = {};
      if (clinicId) {
        params.clinic_id = clinicId;
      }
      // const activeProblemIds = gridRowsData.map(
      //   (row: IPatientProblem) => row.id
      // );
      const activeProblemIds = activeValues.map(
        (row: IPatientProblem) => row.id
      );
      // const checkedDataIds = checkedData.map((row: any) => row.id)
      // const combinedActiveProblems = [
      //   ...activeProblemIds,
      //   ...checkedDataIds
      // ];
      const combinedActiveProblems = [
        ...activeProblemIds
        // ...checkedDataIds
      ];

      const res = await updateCCMPatientDetails({
        ccm_patient_id: patientProblemsData?.ccmPatientId
          ? patientProblemsData?.ccmPatientId
          : patientDetails?.ccm_patient_id,
        clinic_group_id: groupId,
        payload: {
          active_problems: combinedActiveProblems,
          billing_provider: data?.billing_provider
        },
        params
      });
      enqueueSnackbar(res.message, SnackBarConfig('success'));
      closePopUp();
      //  Check if refreshMainGrid exists before calling it
      if (typeof refreshMainGrid === 'function') {
        refreshMainGrid();
      }
    } catch (e) {
      if (e?.message) {
        enqueueSnackbar(e.message, SnackBarConfig('error'));
      }
    }
  };

  // Define the common header style
  const headerStyle = {
    color: DEFAULT_BLACK_COLOR,
    backgroundColor: DEFAULT_WHITE_COLOR,
    fontFamily: APP.FONT_FAMILY.MEDIUM
  };

  // Define the common cell style
  const cellStyle = {
    fontFamily: APP.FONT_FAMILY.REGULAR,
    fontSize: '0.875rem',
    paddingBlock: '0.5rem'
  };

  // eslint-disable-next-line no-shadow
  const {userPermissions} = useSelector((state: State) => state.auth);
  const acOfClinics: any = useSelector(
    (reduxState: any) => reduxState.clinics.selectedClinicId || []
  );

  // const hasDeletePatientProblemConfigPermissions = Permission.hasCCMPermissions(
  //   userPermissions,
  //   AppPermissions.CCM.DELETE_PATIENT_PROBLEM_CONFIG,
  //   groupId
  // );
  const hasAddPatientProblemConfigPermissions = Permission.hasCCMPermissions(
    userPermissions,
    AppPermissions.CCM.CREATE_PATIENT_PROBLEM_CONFIG,
    groupId
  );

  // const handleRemoveCheckedItem = (id: number) => {
  //   setCheckedData((prev) => prev.filter((item) => item.id !== id));
  //   // Uncheck the item in the multi-select dropdown
  // setValue(
  //   'active_problems',
  //   (prev: any) => prev.filter((item: any) => item.id !== id),
  //   { shouldValidate: true }
  // );
  // };

  const handleRemoveCheckedItem = (id: number) => {
    // setCheckedData((prev) => prev.filter((item) => item.id !== id));
    setValue(
      'active_problems',
      activeValues.filter((item: any) => item.id !== id),
      {shouldValidate: true}
    );

    // // Update the dropdown options state directly
    // setDropdownOptions((prevOptions) =>
    //   prevOptions.map((option) =>
    //     option.id === id ? { ...option, checked: false } : option
    //   )
    // );
  };

  // Define the columns in the grid
  const columnList: Array<Column<any>> = [
    {
      title: t('CCM.TABLE_DATA_DETAILS.ICD10_CODE'),
      field: 'icd10_code',
      headerStyle: {
        ...headerStyle,
        width: '15%',
        flex: 1,
        fontSize: '1rem',
        borderLeft: '5px solid transparent'
      },
      cellStyle: {
        ...cellStyle,
        width: '15%',
        flex: 1,
        cursor: 'pointer'
      },
      render: (row: IPatientProblem) => {
        return <div>{row?.icd10_code || '-'}</div>;
      }
    },
    {
      title: t('CCM.TABLE_DATA_DETAILS.PROBLEM'),
      field: 'problem',
      headerStyle: {
        ...headerStyle,
        width: '25%',
        fontSize: '1rem',
        borderLeft: '5px solid transparent'
      },
      cellStyle: {
        ...cellStyle,
        width: '25%',
        cursor: 'pointer'
      },
      render: (row: IPatientProblem) => {
        return <div>{row?.problem || '-'}</div>;
      }
    },
    {
      title: (
        <Trans
          i18nKey={'CCM.TABLE_DATA_DETAILS.IS_CRONIC'}
          components={[<span style={{whiteSpace: 'nowrap'}} key={'X'} />]}
        />
      ),
      sorting: true,
      field: 'is_chronic',
      headerStyle: {
        ...headerStyle,
        width: '10%',
        flex: 1,
        fontSize: '1rem'
      },
      cellStyle: {
        ...cellStyle,
        width: '10%'
      },
      render: (row: IPatientProblem) => {
        let isCronic = '-';
        if (typeof row?.is_chronic === 'boolean') {
          isCronic = row?.is_chronic ? t('COMMON.YES') : t('COMMON.NO');
        }
        return <div>{isCronic}</div>;
      }
    },
    {
      hidden: !(patientProblemsData?.showActiveProblems ?? true),
      title: t('COMMON.ACTIONS'),
      field: 'action',
      sorting: false,
      headerStyle: {
        ...headerStyle,
        width: '5%',
        flex: 1,
        fontSize: '1rem'
      },
      cellStyle: {
        ...cellStyle,
        width: '5%'
      },
      render: (rowData: IPatientProblem) => {
        return (
          <div className={classes.actionsColumnWrapper}>
            {
              <div className={classes.actionIconButtonWrapper}>
                <Tooltip title={t('COMMON.DELETE')} placement="top">
                  <IconButton
                    className={classes.customIconButton}
                    onClick={() => {
                      setDeletePatientProblemConfigDialogState({
                        show: true,
                        id: rowData.id
                      });
                    }}>
                    <Delete />
                  </IconButton>
                </Tooltip>
                <label>{t('COMMON.DELETE')}</label>
              </div>
            }
          </div>
        );
      }
    }
  ];

  const [
    addPatientProblemConfigDialogState,
    setAddPatientProblemConfigDialogState
  ] = useState(false);

  const {control, handleSubmit, setValue, watch, errors} = useForm<any>({
    defaultValues: {
      active_problems: []
    },
    ...(ccmEnrolleData?.ccmDialogOpen
      ? {
          resolver: async function (values) {
            const errorsObj: any = {};
            /* const currentMonth = moment().month();
             const currentYear = moment().year();
             const currentDate = moment().date(); */

            if (!values?.enrollment_start_date) {
              errorsObj.enrollment_start_date = {
                ...errorsObj,
                message: t('CCM.ENROLLMENT_DATE_VALIDATIONS.DATE_REQUIRED')
              };
            } else {
              const enrollmentStartDate = moment(values?.enrollment_start_date);

              if (!enrollmentStartDate.isValid()) {
                errorsObj.enrollment_start_date = {
                  ...errorsObj,
                  message: t('CCM.ENROLLMENT_DATE_VALIDATIONS.INVALID_FORMAT')
                };
              }
              // Fix: Allow users to select any previous date for enrollment date
              /* else if (
               enrollmentStartDate?.month() != currentMonth ||
               enrollmentStartDate?.year() != currentYear ||
               enrollmentStartDate?.date() > currentDate
             ) {
               errorsObj.enrollment_start_date = {
                 ...errorsObj,
                 message: t('CCM.ENROLLMENT_DATE_VALIDATIONS.CURRENT_DATE')
               };
             } */
            }
            return {values, errors: errorsObj};
          }
        }
      : {})
  });
  const [
    deletePatientProblemConfigDialogState,
    setDeletePatientProblemConfigDialogState
  ] = useState({
    show: false,
    id: null
  });
  // const resetPagesInGrid = () => {
  //   if (
  //     tableRef.current?.onQueryChange &&
  //     typeof tableRef.current.onQueryChange === 'function'
  //   ) {
  //     tableRef.current.onQueryChange();
  //   }
  // };

  const handleCloseDeletePatientProblemConfigDialog = async (
    res: 'confirm' | 'cancel'
  ) => {
    if (res === 'confirm' && deletePatientProblemConfigDialogState.id) {
      handleRemoveCheckedItem(deletePatientProblemConfigDialogState.id);
    }
    setDeletePatientProblemConfigDialogState({
      show: false,
      id: null
    });
  };

  const activeValues = watch('active_problems');
  const handleAddPatientProblemSuccess = (newProblem: any) => {
    setValue('active_problems', [...activeValues, newProblem], {
      shouldValidate: true
    });
  };

  const renderGridTable = () => {
    return loader ? (
      <Loader style={{color: 'blue'}} color={'secondary'} size={16} />
    ) : (
      <GridTable
        tableRef={tableRef}
        columns={columnList}
        isLoading={loader}
        data={
          !(patientProblemsData?.showActiveProblems ?? true)
            ? gridRowsData
            : [...activeValues].sort(
                (a, b) =>
                  Number(Boolean(a.disabled ?? false)) -
                  Number(Boolean(b.disabled ?? false))
              )
        }
        options={{
          ...DEFAULT_GRID_TABLE__OPTIONS,
          paging: true,
          sorting: true,
          search: true,
          toolbar: true,
          emptyRowsWhenPaging: false,
          pageSize: PAGINATION_SIZE.PATIENTS,
          pageSizeOptions: PAGINATION_SIZE_OPTIONS,
          showEmptyDataSourceMessage: true,
          maxBodyHeight: '100%',
          rowStyle: {
            height: '52px' // Set row height
          }
        }}
        style={{
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          height: '100%',
          maxHeight: ccmEnrolleData?.ccmDialogOpen ? '45rem' : '',
          overflow: 'auto'
        }}
      />
    );
  };

  const renderBillingProviderFiled = () => {
    return (
      <div
        className="sidesMainView"
        style={{display: 'grid', position: 'relative'}}>
        <Controller
          key={'billing_provider'}
          name={'billing_provider'}
          control={control}
          defaultValue={
            patientProblemsData?.defaultValues?.billing_provider
              ? patientProblemsData?.defaultValues?.billing_provider
              : ''
          }
          render={fieldProps => {
            return (
              <div style={{display: 'grid', position: 'relative'}}>
                <FormField
                  type={'text'}
                  {...fieldProps}
                  label={t('CCM.BILLING_PROVIDER_INPUT_LABEL')}
                  placeholder={t('CCM.BILLING_PROVIDER_PLACEHOLDER')}
                />
              </div>
            );
          }}
        />
      </div>
    );
  };

  const renderPatientProblemsFiled = () => {
    return (
      <div
        className="sidesMainView"
        style={{display: 'grid', position: 'relative'}}>
        <Controller
          key="active_problems"
          name="active_problems"
          control={control}
          defaultValue={[]}
          render={({onChange, value}) => {
            return (
              <div style={{display: 'grid', position: 'relative'}}>
                <FormField
                  type="ccm-problems-multiple-autocomplete"
                  value={value || []}
                  onChange={(selectedValues: any) => {
                    onChange(selectedValues);
                  }}
                  label={t('CCM.ACTIVE_PROBLEMS_INPUT_LABEL')}
                  placeholder={t('CCM.ACTIVE_PROBLEMS_PLACEHOLDER')}
                  fetchOptions={fetchAllPatientProblemsWithMatchingText}
                  disableCloseOnSelect={true}
                  openOnFocus={true}
                  blurOnSelect={false}
                  gridDataLoaded={!loader}
                />
              </div>
            );
          }}
        />
      </div>
    );
  };

  const renderAddPatientProblemButton = () => {
    return (
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          setAddPatientProblemConfigDialogState(true);
        }}>
        {t('CCM.ADD_PATIENT_PROBLEM.TITLE')}
      </Button>
    );
  };
  const renderCCMStartDateField = () => {
    /* const currentDate = new Date();
       const startOfDate = startOfMonth(currentDate); */

    return (
      <FormControl
        fullWidth={true}
        variant="outlined"
        error={errors?.enrollment_start_date?.message}>
        <Controller
          id="enrollment_start_date"
          error={errors?.enrollment_start_date?.message}
          as={
            <DateTimePickerWrapper
              style={{width: '100%'}}
              value={''}
              // minDate={startOfDate}
              maxDate={new Date()}
              inputProps={{
                name: 'enrollment_start_date',
                id: 'enrollment_start_date',
                required: true
              }}
              placeholder={t(
                'PATIENT_DETAILS_DRAWER.CCM_MODULE.SELECT_MONTH_AND_YEAR'
              )}
              onChange={value => {
                handleOnChange(value, null, 'enrollment_start_date');
                // setValue('enrollment_start_date', value);
              }}
            />
          }
          margin={'dense'}
          control={control}
          name={'enrollment_start_date'}
          type={'string'}
          value={'text'}
          autoComplete="on"
          placeholder={t(
            'PATIENT_DETAILS_DRAWER.CCM_MODULE.SELECT_MONTH_AND_YEAR'
          )}
          defaultValue={moment()}
        />
        {errors?.enrollment_start_date?.message && (
          <FormHelperText>
            {t(errors.enrollment_start_date.message)}
          </FormHelperText>
        )}
      </FormControl>
    );
  };
  const renderContent = () => {
    return (
      <div style={{...spaceBottomStyle}}>
        <Grid container direction="row" justify="space-between">
          <Grid item>
            <div style={{...spaceBottomStyle}}>{t('CCM.BILLING_MONTH')}</div>
            <div style={{...billingMonthTextColor}}>{BillingMonth}</div>
          </Grid>
          <Grid item>
            <div style={{marginBottom: '0.25rem'}}>{t('CCM.START_DATE')}</div>
            <div className={classes.ccmStartDateFeild}>
              {renderCCMStartDateField()}
            </div>
          </Grid>
        </Grid>
      </div>
    );
  };
  const renderDrapAndDropFileUpload = () => {
    return (
      <div>
        <DragAndDrop
          title={
            <Trans
              i18nKey={'COMMON.UPLOAD_FILE'}
              components={[
                <label className="drop-title" key={'X'} />,
                <span className="drop-title" key={'Y'} />,
                <span className="drop-title" key={'Z'} />
              ]}
            />
          }
          multiple={false}
          showSelectedFile
          handleFileChange={handleConsentFileChange}
          acceptFileTypes={'.jpeg,.jpg,.doc,.docx,.png,.titf,.pdf'}
        />
      </div>
    );
  };
  const renderRadioButtons = () => {
    return (
      <Grid item style={{...spaceBottomStyle}}>
        <RadioGroup
          aria-label="consent"
          name="consent"
          value={consentType}
          style={{
            display: 'flex',
            flexDirection: 'row'
          }}
          onChange={handleConsentTypeChange}>
          <FormControlLabel
            value={t('CCM.VERBAL')}
            control={<Radio />}
            label={t('CCM.VERBAL_CONSENT')}
            className={classes.ConsentRadioStyle}
          />
          <FormControlLabel
            value={t('CCM.WRITTEN')}
            control={<Radio />}
            label={t('CCM.WRITTEN_CONSENT')}
            className={classes.ConsentRadioStyle}
          />
        </RadioGroup>
      </Grid>
    );
  };
  const renderTextArea = () => {
    return (
      <div>
        <TextareaAutosize
          rowsMax={10}
          rows={4}
          aria-label="maximum height"
          placeholder={t('CCM.ENTER_SOME_NOTES')}
          className="app-text-area"
          onChange={handleVerbalNotesChange}
          value={verbalNotes}
          style={{color: FONT_PRIMARY_COLOR, opacity: '1'}}
        />
      </div>
    );
  };
  const renderDialogContent = () => {
    return (
      <div>
        {renderContent()}
        <Grid>
          {renderRadioButtons()}
          <Grid item>
            <div style={{...spaceBottomStyle}}>
              {consentType === t('CCM.VERBAL')
                ? `${t('CCM.NOTES')}*`
                : `${t('CCM.NOTES')}`}
            </div>
            <FormControl fullWidth={true} variant="outlined">
              {renderTextArea()}
            </FormControl>
            <div style={{...spaceBottomStyle}}>
              {consentType === t('CCM.WRITTEN')
                ? `${t('CCM.CONSENT_FORM')}*`
                : `${t('CCM.CONSENT_FORM')}`}
            </div>
            <FormControl fullWidth={true} variant="outlined">
              {renderDrapAndDropFileUpload()}
            </FormControl>
          </Grid>
        </Grid>
      </div>
    );
  };
  const renderDialogTitle = () => {
    return (
      <div>
        {t('CCM.ENROLL_INTO_CCM', {patientName: patientName})}
        <strong>&nbsp;&nbsp;&bull;&nbsp;&nbsp;</strong>
        {`${accountNumber})`}
      </div>
    );
  };
  const [isMobile, setIsMobile] = useState(false);

  // Hook to check the window width
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1500) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };

    // Initialize the check on component mount
    handleResize();

    // Add event listener to update the state when window is resized
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener when component unmounts
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <Drawer
      disableEnforceFocus
      anchor={'right'}
      open={open}
      className={[classes.drawer].join(' ')}
      onClose={() => {
        closePopUp();
      }}
      PaperProps={
        ccmEnrolleData?.ccmDialogOpen && {
          style: {
            width: isMobile ? '100vw' : '85vw'
          }
        }
      }
      style={{zIndex: 1200}}>
      <div className={`drawer-component-wrapper ${classes.drawerWrapper}`}>
        <div className={`content-view ${classes.drawerTitleAndBody}`}>
          {/* header and close section start */}
          <div className={`header-and-close-section ${classes.titleSection}`}>
            <div className="header-view">
              <span>
                {ccmEnrolleData?.ccmDialogOpen
                  ? renderDialogTitle()
                  : t(
                      'CCM.TABLE_DATA_DETAILS.PATIENT_PROBLEM_CONFIGURATIONS_DRAWER_TITLE'
                    )}
              </span>
            </div>
            <div style={{display: 'flex', gap: '0.5rem', alignItems: 'center'}}>
              {patientProblemsData?.showActiveProblems && (
                <Button
                  variant="outlined"
                  color="primary"
                  className={classes.moreFilters}
                  onClick={handleSubmit(handleCCMPatientDetails)}>
                  {t('COMMON.SAVE')}
                </Button>
              )}
              {ccmEnrolleData?.ccmDialogOpen && (
                <Button
                  type="submit"
                  variant={'contained'}
                  onClick={handleSubmit(handleEnrollClick)}
                  color="primary"
                  className={classes.moreFilters}
                  disabled={disableEnrollButton()}>
                  {buttonLoader ? (
                    <Loader
                      style={{color: 'white'}}
                      color={'secondary'}
                      size={21}
                    />
                  ) : (
                    t('COMMON.ENROLL')
                  )}
                </Button>
              )}
              <Button
                color="primary"
                variant="outlined"
                onClick={(): void => closePopUp()}>
                {t('COMMON.CLOSE')}
              </Button>
            </div>
          </div>
          {patientProblemsData?.open && (
            <>
              {patientProblemsData?.showBillingProvider && (
                <div
                  style={{
                    width: '50%',
                    marginLeft: '1rem',
                    marginTop: '1rem',
                    marginBottom: '2rem'
                  }}>
                  {renderBillingProviderFiled()}
                </div>
              )}
              {patientProblemsData?.showActiveProblems && (
                <div
                  style={{
                    display: 'flex',
                    gap: '1rem',
                    flexDirection: 'row',
                    marginTop: '1rem'
                  }}>
                  <div style={{width: '50%', marginLeft: '1rem'}}>
                    {renderPatientProblemsFiled()}
                  </div>
                  <div style={{marginTop: '21px'}}>
                    {hasAddPatientProblemConfigPermissions &&
                      renderAddPatientProblemButton()}
                  </div>
                </div>
              )}
              <div className={classes.patientProblemsGridWrapper}>
                {renderGridTable()}
              </div>
            </>
          )}
          {ccmEnrolleData?.ccmDialogOpen && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                marginLeft: '1rem',
                marginTop: '2rem',
                gap: '1rem'
              }}>
              <div style={{width: '35%'}}>{renderDialogContent()} </div>
              <div style={{width: '65%'}}>
                {ccmEnrolleData?.ccmDialogOpen && (
                  <>
                    <div
                      style={{
                        width: '50%',
                        marginLeft: '1rem',
                        marginBottom: '2rem'
                      }}>
                      {renderBillingProviderFiled()}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        gap: '1rem',
                        flexDirection: 'row'
                      }}>
                      <div style={{width: '50%', marginLeft: '1rem'}}>
                        {renderPatientProblemsFiled()}
                      </div>
                      <div style={{marginTop: '21px'}}>
                        {hasAddPatientProblemConfigPermissions &&
                          renderAddPatientProblemButton()}
                      </div>
                    </div>
                  </>
                )}
                <div className={classes.patientProblemsGridWrapper}>
                  {renderGridTable()}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {addPatientProblemConfigDialogState && (
        <AddPatientProblem
          open={addPatientProblemConfigDialogState}
          onClose={() => setAddPatientProblemConfigDialogState(false)}
          clinicGroupId={groupId}
          clinicId={clinicId}
          onSuccess={handleAddPatientProblemSuccess}
        />
      )}
      {deletePatientProblemConfigDialogState.show && (
        <DeleteAlert
          open={deletePatientProblemConfigDialogState.show}
          close={handleCloseDeletePatientProblemConfigDialog}
          title={t('CCM.DELETE_PATIENT_PROBLEM.TITLE')}
          description={t('CCM.DELETE_PATIENT_PROBLEM.SUB_TITLE')}
        />
      )}
    </Drawer>
  );
};
export default WithPermission(
  CCMPatientProblemsDrawer,
  AppPermissions.CCM.NAME,
  AppPermissions.CCM.CREATE
);
